// extracted by mini-css-extract-plugin
export default {"dynamic-tag-view":"f89qO_dynamic-tag-view"};